import ja from "date-fns/locale/ja";
import Link from "next/link";

import { CalendarServiceType } from "@/apis/clients";
import { CalendarServiceBudge } from "@/components/atoms/budge/CalendarServiceBudge";
import { Button } from "@/components/atoms/buttons/Button";
import {
  Modal,
  ModalFoot,
  ModalHead,
  Sizes,
} from "@/components/molecules/modals/Modal";
import { CalendarEvent } from "@/components/organisms/mypage/MyPageCalendar";
import { calendarServiceToString } from "@/libs/enums/enumStrings";
import { dateFormatType } from "@/utils/common";
import { NEXT_URL } from "@/utils/const";
import { DateFormat, format } from "@/utils/date";

import ChevronIcon from "public/icon/chevron-right.svg";

function eventToTime({ start, end }: CalendarEvent): string {
  const timeStart = format(start, DateFormat.HOURS_MINUTES);
  const timeEnd = format(end, DateFormat.HOURS_MINUTES);
  return `${timeStart} 〜 ${timeEnd}`;
}

interface Props {
  isOpen: boolean;
  date: Date;
  events: CalendarEvent[];
  handleClose: () => void;
}

export default function CalendarDateModal({
  isOpen,
  date,
  events,
  handleClose,
}: Props) {
  const href_url = (event: CalendarEvent) => {
    if (event.type === CalendarServiceType.CALENDAR) {
      return {
        pathname: NEXT_URL.RESERVATIONS_DETAIL,
        query: { id: event.id },
      };
    } else {
      return {
        pathname: NEXT_URL.SERVICES_DETAIL,
        query: { id: event.service_id },
      };
    }
  };

  return (
    <Modal isOpen={isOpen} handleClose={handleClose} size={Sizes.XXXL}>
      <ModalHead
        title={
          format(date, dateFormatType.FULL_DATE_JP, { locale: ja }) + "の予定"
        }
        onClickClose={handleClose}
        isShowCloseBtn={false}
        className="md:pl-6"
      />
      <ul className="pt-4 pb-6 pl-6 pr-9">
        {events.map((e) => (
          <li key={e.id} className="w-full border-b border-[#E5E7EB]">
            <Link
              href={href_url(e)}
              className="flex justify-between items-center rounded py-2 pr-1 transition hover:bg-primary/10">

              <div className="flex items-center space-x-3">
                <CalendarServiceBudge
                  text={calendarServiceToString(e.type)}
                  statusVal={e.type}
                />
                <p className="shrink-0">{eventToTime(e)}</p>
                <p className="break-word">{e.customer_name || e.name}</p>
              </div>
              <div className="shrink-0">
                <ChevronIcon width={24} height={24} />
              </div>

            </Link>
          </li>
        ))}
      </ul>
      <ModalFoot className="!justify-center px-6">
        <Button label="閉じる" color="bg-white" onClick={handleClose} />
      </ModalFoot>
    </Modal>
  );
}
